import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { retrieveFromLocalStorage } from '../../../utils/util';

import { requestViewPersonProductListings } from '../../../api/product/product.actions';
import { setProduct } from '../../../slices/market-buzz/market-buzz.slice';

import MyProductListings from '../../../components/screens/shop/my-product-listings/MyProductListings';

const MyProductListingsContainer = () => {
  const { productListings } = useSelector(({ product }) => product);
  const currencyCode = useSelector(({ currency }) => currency.currencyCode);

  const personExternalReference = useRef(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    personExternalReference.current = retrieveFromLocalStorage('personExternalReference');

    const filters = { personExternalReference: personExternalReference.current };

    dispatch(requestViewPersonProductListings({ filters }));
  }, [dispatch, currencyCode]);

  const applyFilters = (filtersToApply) => {
    const filters = {
      ...filtersToApply,
      personExternalReference: personExternalReference.current,
    };

    dispatch(requestViewPersonProductListings({ filters }));
  };

  const buzzProduct = (product) => {
    dispatch(setProduct(product));
    navigate('/market/market-buzz/create');
  };

  return (
    <MyProductListings
      listings={productListings}
      applyFilters={applyFilters}
      buzzProduct={buzzProduct}
      currencyCode={currencyCode}
    />
  );
};

export default MyProductListingsContainer;
